export default __webpack_public_path__ + "static/media/breakpact.1b9207a2.png";